import { ApButtonSecondary, ApButtonTab } from '@alixpartners/ui-components';
import React, { useState } from 'react';
import { ContentDiv, FlexWrapper, NavDiv } from './WorkingCapital.styles';
import DataUpdate from './Data Update/DataUpdate';
import SavingCalulation from './Saving Calulation/SavingCalulation';
import Dashboard from './Dashboard/Dashboard';
import withCapitalMarketProviders from './HOCs/withCapitalMarketProviders';
import WCBenchmark from './Benchmark/WCBenchmark';
import { BackButtonWrapper } from '../CategoryWidget.styles';

const WorkingCapital = ({ setCurrentContent }) => {
	const INITIAL_SUBNAV_CONFIG = [
		{
			id: 0,
			name: 'dataupdate',
			label: 'Data Update',
			isActive: true,
			component: DataUpdate,
		},
		{
			id: 1,
			name: 'Dashboard',
			label: 'Dashboard',
			isActive: false,
			component: Dashboard,
		},
		{
			id: 2,
			name: 'savingscalulation',
			label: 'WC Improvement',
			isActive: false,
			component: SavingCalulation,
		},
		{
			id: 3,
			name: 'wcbenchmark',
			label: 'WC Benchmark',
			isActive: false,
			component: WCBenchmark,
		},
	];

	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};
	return (
		<>
			<FlexWrapper>
				<NavDiv>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
				<BackButtonWrapper>
					<ApButtonSecondary small onClick={() => setCurrentContent(0)}>
						Back
					</ApButtonSecondary>
				</BackButtonWrapper>
			</FlexWrapper>

			{subNav.map(({ id, isActive, component: Component }) => {
				return (
					isActive && (
						<ContentDiv id={id}>
							<Component key={id} setCurrentContent={setCurrentContent} />
						</ContentDiv>
					)
				);
			})}
		</>
	);
};

export default withCapitalMarketProviders(WorkingCapital);
